import React from 'react'
import Topbar from '../Topbar/Topbar';
import { useState } from 'react';
import { Col, Container, Row } from 'react-bootstrap';
import './View_Installation.css'
import { FaUserEdit } from "react-icons/fa";
import { MdEdit } from "react-icons/md";
import Order_Details from './Order_Details';
import Verification from './Verification';
import WorkAssign from './WorkAssign';
import Work_Details from './Work_Details';
import Feedback from './Feedback';
import Payment from './Payment';
import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { MdDelete } from "react-icons/md";
import axios from "axios";
import Swal from "sweetalert2";
import dayjs from 'dayjs';
import { useRef } from "react";
import _ from 'lodash';
import { FaStarOfLife } from "react-icons/fa6";
import { FiX, FiUpload } from "react-icons/fi"; // Close & Upload icons

import { useLocation } from "react-router-dom";
import { useSelector } from "react-redux";
import MessageBox from '../MessageBox/MessageBox';

export default function View_Installation() {



  const location = useLocation();
  const { leadId, activeTabWorkAssign: routeActiveTab, hideAssignButton,tabInfo, isSubmittedTab,resubmittedData,activeTabfromInstall } = location.state || {};
  const taskId = location.state?.taskId;

  const locationDetails =location?.state

  console.log(locationDetails,"location Details")

  console.log(resubmittedData,"resubmitedDate")
  console.log(taskId, 123)
  const Id = useSelector((state) => state.id);
  const [completedTabs, setCompletedTabs] = useState([]);
  const [ottData, setOttData] = useState([]);
  const [showMessageBox, setShowMessageBox] = useState(false);
  const [activeTabWorkAssign, setActiveTabWorkAssign] = useState("fiberTeam");

  

  const permissions = useSelector((state) => state.permissions);



  const [searchText, setSearchText] = useState('');
  const [routerMaterial, setRouterMaterial] = useState([]);


  const [approvePerson, setApprovePerson] = useState(null);  // initially no one selected
  const [approvePersons, setApprovePersons] = useState([]);  // Array of selected persons
  const [isApproveOpen, setIsApproveOpen] = useState(false);
  const approveDropdownRef = useRef(null);
  const [installmessageData, setInstallMessageData] = useState([]);
  const [messageData, setMessageData] = useState([]);
  const [enquirymessageData, setEnquiryMessageData] = useState([]);



  // const [activeTab, setActiveTab] = useState("orderDetails");


  const [isOpenAssign, setIsOpenAssign] = useState(false);
  const [pageRefId, setpageRefId] = useState("")


  const [activeTab, setActiveTab] = useState(  "orderDetails");


useEffect(() => {
  console.log("Route Active Tab (workAssign subtab):", routeActiveTab);

  if (routeActiveTab === "fiberTeam" || routeActiveTab === "networkTeam") {
    setActiveTab("workAssign"); // Always go to workAssign tab
    setActiveTabWorkAssign(routeActiveTab); // fiberTeam or networkTeam
  }
}, [routeActiveTab]);

  const apiUrl = process.env.REACT_APP_API_BASE_URL;
  const locate = useLocation();
  const [rows, setRows] = useState([]);


console.log(activeTabWorkAssign,"workassignactive tb")
  // const [isEditable, setIsEditable] = useState(true);
  const [isEditable, setIsEditable] = useState(false); // ❌ NOT true

  const [isEditMode, setIsEditMode] = useState(false);
  const staffName = useSelector((state) => state.staffname);
  console.log(staffName)

  // to track update mode
  const [originalComplaint, setOriginalComplaint] = useState(null);
  const [installDetails, setinstallDetails] = useState({})
  const [originalData, setOriginalData] = useState({});
  const [enquiryId, setEnquiryId] = useState(null);
  
  // Add this to your component

  const listView = () => {
    axios
      .post(apiUrl + "viewlead", {})
      .then((res) => {
        setRows(res.data.message);
      })
      .catch((error) => {
        console.error("Error fetching data", error);
      });
  }

  useEffect(() => {
    listView()
  }, []);




  const renderContent = () => {
    switch (activeTab) {
      case "orderDetails":
        return <div>

          <Order_Details
            installDetails={installDetails}
            setinstallDetails={setinstallDetails}
            isEditable={isEditable}
            names={salesNames}
            setNames={setNames} />

        </div>;
      case "verification":
        return <div>
          <Verification installDetails={installDetails}
            setinstallDetails={setinstallDetails} isSubmitting={isSubmitting} handleSubmit={handleSubmit} selectedFile={selectedFile}
            setSelectedFile={setSelectedFile} />
        </div>;
      case "workAssign":
        return <div>
          <WorkAssign
            installDetails={installDetails}
            setinstallDetails={setinstallDetails}
            isSubmitting={isSubmitting}
            fiberTeamStock={fiberTeamStock}
            setFiberTeamStock={setFiberTeamStock}
            networkTeamStock={networkTeamStock}
            setNetworkTeamStock={setNetworkTeamStock}
            activeTabWorkAssign={activeTabWorkAssign}
            setActiveTabWorkAssign={setActiveTabWorkAssign}
         
          />

        </div>;
      case "workDetails":
        return <div><Work_Details installDetails={installDetails}
          setinstallDetails={setinstallDetails} isSubmitting={isSubmitting} /></div>;
      case "feedback":
        return <div><Feedback installDetails={installDetails}
          setinstallDetails={setinstallDetails} isSubmitting={isSubmitting} /></div>;
      case "payment":
        return <div><Payment installDetails={installDetails}
          setinstallDetails={setinstallDetails} isSubmitting={isSubmitting} /></div>;
      default:
        return <div>Select a tab</div>;
    }
  };



  const [taskData, setTaskData] = useState({
    taskName: 'Installation',
    assignDateTime: '',
    taskType: 'Once',
    taskPriority: 'Low',
    deadline: '',
    time: '',
    assignedTo: [], // Array for multiple selections
    approvePerson: '',
    description: '',
    name: '',
    leadId: '',
    taskStatus: 'Open',
    assignedBy: '',
    activeTabWorkAssign: activeTabWorkAssign
  });


  console.log(activeTab)

  console.log(installDetails.installcustomerName)

  useEffect(() => {
    if (installDetails) {
      setTaskData(prev => ({
        ...prev,
        name: installDetails.installcustomerName || '',
        leadId: installDetails.leadId || '' // if you also want to set leadId here
      }));
    }
  }, [installDetails]);


  console.log(installDetails.installcustomerName)






  useEffect(() => {
    if (staffName) {
      setTaskData((prev) => ({ ...prev, assignedBy: staffName }));
    }
  }, [staffName]);

  console.log(taskData.staffName)





  const [selectedFile, setSelectedFile] = useState(null);


  const [isOpenAdvancePayment, setIsOpenAdvancePayment] = useState(false)

  // Handle file selection




  const navigate = useNavigate();




  const [selectedNames, setSelectedNames] = useState([]);
  const [names, setNames] = useState([]);
    const [salesNames, setSalesNames] = useState([]);


  const [namesApprove, setNamesApprove] = useState([]);

  const [searchTerm, setSearchTerm] = useState("");

  const filteredNames = namesApprove.filter(staff =>
    staff.staffName.toLowerCase().includes(searchTerm.toLowerCase())
  );
  const [isOpen, setIsOpen] = useState(false);
  const dropdownRef = useRef(null);
   const formatDateTimeLocal = (date) => {
   const year = date.getFullYear();
   const month = (date.getMonth() + 1).toString().padStart(2, "0");
   const day = date.getDate().toString().padStart(2, "0");
   const hours = date.getHours().toString().padStart(2, "0");
   const minutes = date.getMinutes().toString().padStart(2, "0");
 
   return `${year}-${month}-${day}T${hours}:${minutes}`;
 };
 
 
 
 useEffect(() => {
   if (taskData.assignDateTime) {
     const assignDate = new Date(taskData.assignDateTime);
     const deadlineDate = new Date(assignDate.getTime() + 4 * 60 * 60 * 1000); // +4 hours
     const formattedDeadline = formatDateTimeLocal(deadlineDate);
 
     setTaskData(prev => ({
       ...prev,
       deadline: formattedDeadline
     }));
   }
 }, [taskData.assignDateTime]);
 
 
 
 
 
const handleInputChange = (field, value) => {
  if (field === 'assignDateTime') {
    const assignDate = new Date(value);
    const deadlineDate = new Date(assignDate.getTime() + 4 * 60 * 60 * 1000);
    const formattedDeadline = deadlineDate.toISOString().slice(0, 16);

    setTaskData(prev => ({
      ...prev,
      assignDateTime: value,
      deadline: formattedDeadline // auto update
    }));
  } else {
    setTaskData(prev => ({
      ...prev,
      [field]: value
    }));
  }
};

 


 
useEffect(() => {
  axios.get(apiUrl + "get-staff-names")
    .then((res) => {
      if (res.data.message) {
        const allStaff = res.data.message;

        setSalesNames(res.data.message)
        let filtered = [];

        if (activeTabWorkAssign === "fiberTeam") {
          filtered = allStaff.filter(
            staff =>
              staff.designation === "Fiber Engineer" ||
              staff.designation === "Marketing / Fiber"
          );
        } else if (activeTabWorkAssign === "networkTeam") {
          filtered = allStaff.filter(
            staff =>
              staff.designation === "Network Admin" ||
              staff.designation === "Network Engineer"
          );
        }


          let filteredApprove = [];

        if (activeTabWorkAssign === "fiberTeam") {
          filteredApprove = allStaff.filter(
            staff =>
              staff.designation === "Network Admin" ||
              staff.designation === "Admin"
          );
        } else if (activeTabWorkAssign === "networkTeam") {
          filteredApprove = allStaff.filter(
            staff =>
              staff.designation === "Network Admin" ||
              staff.designation === "Admin"
          );
        }

        setNamesApprove(filteredApprove);

        setNames(filtered);
      }
    })
    .catch((err) => {
      console.log("Error fetching staff names:", err);
    });



  const handleClickOutside = (event) => {
    if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
      setIsOpen(false);
    }
  };

  document.addEventListener('mousedown', handleClickOutside);
  return () => {
    document.removeEventListener('mousedown', handleClickOutside);
  };
}, [activeTabWorkAssign]); 




    console.log(salesNames,"namessales")


// <-- triggers when tab changes
 // Include this dependency to update on tab change




  // Toggle dropdown open/close
  const toggleDropdown = () => {
    setIsOpen(prev => !prev);
  };

  // Checkbox change handler expects a staffName string
  const handleCheckboxChange = (staff) => {
    setSelectedNames(prev => {
      const exists = prev.find(item => item._id === staff._id);
      if (exists) {
        // remove staff
        return prev.filter(item => item._id !== staff._id);
      } else {
        // add staff
        return [...prev, staff];
      }
    });
  };





  // Display text: show staff names of selected IDs
  const displayText = selectedNames.length > 0
    ? selectedNames.map(item => item.staffName).join(', ')
    : 'Select names';


  // State initialization

  useEffect(() => {
    axios.post(apiUrl + "viewott", {}).then((res) => {
      const add_installation = res.data.message || [];
      console.log("Fetched data:", add_installation); // ✅ Check this output

      setOttData(add_installation);


    });
  }, []);

  const [isSubmitting, setIsSubmitting] = useState(false);



  const [fiberTeamStock, setFiberTeamStock] = useState({
    updatedBy: staffName,
    updatedTime: new Date().toLocaleTimeString(),
    updatedDate: new Date().toLocaleDateString(),
    materials: [],
  });

  const [networkTeamStock, setNetworkTeamStock] = useState({
    updatedBy: staffName,
    updatedTime: new Date().toLocaleTimeString(),
    updatedDate: new Date().toLocaleDateString(),
    materials: [],
  });


  console.log(installDetails,"jnkfjdd")


const handleSubmit = async (e) => {
  e.preventDefault();
  setIsSubmitting(true);

  if (isEditMode && _.isEqual(installDetails, originalComplaint)) {
    Swal.fire("No Changes", "No changes were made to update.", "info");
    setIsSubmitting(false);
    return;
  }

  const result = await Swal.fire({
    title: "Update the changes?",
    showCancelButton: true,
    confirmButtonText: "Update",
  });

  if (!result.isConfirmed) {
    setIsSubmitting(false);
    return;
  }

  try {
    const now = new Date();
    const day = String(now.getDate()).padStart(2, "0");
    const month = String(now.getMonth() + 1).padStart(2, "0");
    const year = now.getFullYear();
    const updatedDate = `${day}-${month}-${year}`;
    let hours = now.getHours();
    const minutes = String(now.getMinutes()).padStart(2, "0");
    const ampm = hours >= 12 ? "PM" : "AM";
    hours = hours % 12 || 12;
    const updatedTime = `${hours}:${minutes} ${ampm}`;

    let updatedInstallDetails = { ...installDetails };

    updatedInstallDetails[activeTab] = {
      ...(updatedInstallDetails[activeTab] || {}),
      updatedBy: staffName,
      updatedDate,
      updatedTime,
    };

    // === Work Assign Tab (✅ Fixed here) ===
if (activeTab === "workAssign" && activeTabWorkAssign === "fiberTeam") {
  const prevFiberTeam = installDetails?.workAssign?.fiberTeam || {};
  const prevMaterials = prevFiberTeam.materials || [];
  const newMaterials = fiberTeamStock.materials || [];

  updatedInstallDetails.workAssign = {
    ...installDetails.workAssign,
    fiberTeam: {
      ...prevFiberTeam,
      ...fiberTeamStock,
      materials: [...prevMaterials, ...newMaterials], // ✅ merge materials
      isCompleted: true,
      updatedBy: staffName,
      updatedDate,
      updatedTime,
    },
  };
}


if (activeTab === "workAssign" && activeTabWorkAssign === "networkTeam") {
  const prevNetworkTeam = installDetails?.workAssign?.networkTeam || {};
  const prevMaterials = prevNetworkTeam.materials || [];
  const newMaterials = networkTeamStock.materials || [];

  updatedInstallDetails.workAssign = {
    ...installDetails.workAssign,
    networkTeam: {
      ...prevNetworkTeam,
      ...networkTeamStock,

      // ✅ Avoid overwriting with empty array
           materials: [...prevMaterials, ...newMaterials], // ✅ merge materials


      isCompleted: true,
      updatedBy: staffName,
      updatedDate,
      updatedTime,
    },
  };


    
              const workDetailPayload = {
                type: "installation", // You can change this to "complaint" or "installation" as needed
                pageRefId: installDetails._id,
                staffId: Id,
                staffName: staffName,
                actionStatus: "complete",
                // Optional fields:
                // bikeType: ...,
                // cableUsed: ...,
                // location: { latitude: ..., longitude: ... },
              };
  
              try {
                await axios.post(apiUrl + "work-detail", workDetailPayload, {
                  headers: { "Content-Type": "application/json" },
                });
                console.log("Work detail logged successfully.");
              } 
              catch (err) {
                console.error("Work detail logging failed:", err.response?.data || err.message);
              }
            
}





    // === Verification Tab ===
    else if (activeTab === "verification") {
      const status = updatedInstallDetails.verification?.verificationStatus;
      updatedInstallDetails.verification = {
        ...(updatedInstallDetails.verification || {}),
        isCompleted: status === "Verified",
        updatedBy: staffName,
        updatedDate,
        updatedTime,
      };

      // Message box
      const formData = new FormData();
      const verificationStatus = installDetails.verification?.verificationStatus?.toLowerCase().trim();
      let colorCode = "black";
      if (verificationStatus === "open") colorCode = "#ffc107";
      else if (verificationStatus === "verified") colorCode = "#2c693a";
      else if (verificationStatus === "not available") colorCode = "#ff0000";

      formData.append("pageRefId", installDetails._id);
      formData.append("page", "Installation");
      formData.append("colorCode", colorCode);
      formData.append(
        "description",
        `${installDetails.verification?.notes || ""} (${installDetails.verification?.verificationStatus || "Not Available"})`
      );
      formData.append("staffPic", "");
      if (selectedFile) formData.append("image", selectedFile);
      formData.append("updatesHistory[staff][name]", staffName);
      formData.append("updatesHistory[staff][id]", Id);
      formData.append("updatesHistory[status]", "Verification");

      await axios.post(apiUrl + "add-message", formData, {
        headers: { "Content-Type": "multipart/form-data" },
      });

      const res = await axios.get(`${apiUrl}messages/${pageRefId}`);
      setMessageData(res.data.data);
      setShowMessageBox(true);
    }

    // === Feedback Tab ===
    else if (activeTab === "feedback") {
      updatedInstallDetails.feedback = {
        ...(updatedInstallDetails.feedback || {}),
        isCompleted: true,
        updatedBy: staffName,
        updatedDate,
        updatedTime,
      };
    }

    // === Payment Tab ===
    else if (activeTab === "payment") {
      updatedInstallDetails.payment = (updatedInstallDetails.payment || []).map((p) => ({
        ...p,
        isCompleted: true,
      }));
    }

    // === Task status update for workAssign or workDetails
    if (activeTab === "workAssign" || activeTab === "workDetails") {
      await axios.put(apiUrl + "update-task", {
        id: taskId,
        updateData: {
          taskStatus: "Completed",
          taskUpdatedBy: {
            staffName,
            _id: Id,
            time: updatedTime,
            date: updatedDate,
          },
        },
      });
    }

    // === Save installation update
    await axios.post(apiUrl + "update-lead-install", updatedInstallDetails, {
      headers: { "Content-Type": "application/json" },
    });

    Swal.fire("Success!", "Data updated successfully", "success");
    setIsEditable(false);
    setIsEditMode(false);

    if (activeTab === "orderDetails") {
      navigate("/view_installation");
    } else if (["verification", "feedback", "payment"].includes(activeTab)) {
      navigate("/installation");
    } else {
      navigate("/task");
    }
  } catch (error) {
    Swal.fire("Error", error.response?.data?.message || "Something went wrong!", "error");
  } finally {
    setIsSubmitting(false);
  }
};



const handleCancel = async (e) => {
  e.preventDefault();

  const result = await Swal.fire({
    title: "Do you want to cancel the installation?",
    icon: "warning",
    showCancelButton: true,
    confirmButtonText: "Yes, Cancel",
    cancelButtonText: "No",
  });

  // Stop here if the user cancels
  if (!result.isConfirmed) return;

  try {
    setIsSubmitting(true); // Optional loading flag

    const now = new Date();
    const day = String(now.getDate()).padStart(2, "0");
    const month = String(now.getMonth() + 1).padStart(2, "0");
    const year = now.getFullYear();
    const updatedDate = `${day}-${month}-${year}`;
    let hours = now.getHours();
    const minutes = String(now.getMinutes()).padStart(2, "0");
    const ampm = hours >= 12 ? "PM" : "AM";
    hours = hours % 12 || 12;
    const updatedTime = `${hours}:${minutes} ${ampm}`;

    // Create updated installation object
    let updatedInstallDetails = {
      ...installDetails,
      leadStatus: "Cancelled", // ✅ mark status as Cancelled
      
    };

    // Post update to backend
    await axios.post(apiUrl + "update-lead-install", updatedInstallDetails, {
      headers: { "Content-Type": "application/json" },
    });

    await Swal.fire("Success!", "Installation cancelled successfully", "success");

    // Reset state and navigate
    setIsEditable(false);
    setIsEditMode(false);
    navigate("/installation");

  } catch (error) {
    Swal.fire("Error", error.response?.data?.message || "Something went wrong!", "error");
  } finally {
    setIsSubmitting(false);
  }
};





  const page = "installation"; // static page value



  const toggleApproveDropdown = () => {
    setIsApproveOpen(prev => !prev);
  };


  const handleApproveCheckboxChange = (staff) => {
    setApprovePersons(prev => {
      const exists = prev.find(item => item._id === staff._id);
      if (exists) {
        // Remove staff
        return prev.filter(item => item._id !== staff._id);
      } else {
        // Add staff
        return [...prev, staff];
      }
    });
  };
  const approvePersonText = approvePersons.length > 0
    ? approvePersons.map(item => item.staffName).join(', ')
    : 'Select Approve Persons';

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsOpen(false);
      }
      if (approveDropdownRef.current && !approveDropdownRef.current.contains(event.target)) {
        setIsApproveOpen(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);


  useEffect(() => {
  setTaskData(prev => ({
    ...prev,
    activeTabWorkAssign: activeTabWorkAssign
  }));
}, [activeTabWorkAssign]);


  const handleSubmitAssignTask = async (e) => {
    e.preventDefault();

    Swal.fire({
      title: "Are you sure you want to create this task?",
      showCancelButton: true,
      confirmButtonText: "Submit",
    }).then(async (result) => {
      if (result.isConfirmed) {
        try {
          const now = new Date();
          const day = String(now.getDate()).padStart(2, "0");
          const month = String(now.getMonth() + 1).padStart(2, "0");
          const year = now.getFullYear();
          const updatedDate = `${day}-${month}-${year}`;

          let hours = now.getHours();
          const minutes = String(now.getMinutes()).padStart(2, "0");
          const ampm = hours >= 12 ? "PM" : "AM";
          hours = hours % 12 || 12;
          const updatedTime = `${hours}:${minutes} ${ampm}`;

          const datas = {
            ...taskData,
            assignedBy: {
              staffName: staffName,
              id: Id
            },
            updatedDate,
            updatedTime,
            assignedTo: selectedNames,
            approvePerson: approvePersons,
            collectionId: enquiryId
          };

          // Required fields to check
          const requiredFields = [
            "taskName",
            "assignDateTime",
            // "taskPriority",
            // "taskType",
            "deadline",
            "assignedTo",
            "approvePerson",
            "description",
          ];

          // Check for empty fields
          const emptyFields = requiredFields.filter(
            (field) => !datas[field] || (Array.isArray(datas[field]) && datas[field].length === 0)
          );

          if (emptyFields.length > 0) {
            Swal.fire({
              icon: "warning",
              title: "Incomplete Data",
              text: `Please fill all the fields:`,
            });
            return;
          }

          const response = await axios.post(
            apiUrl + "add-assign-task",
            datas,
            { headers: { "Content-Type": "application/json" } }
          );
if (taskData.activeTabWorkAssign === "fiberTeam") {
  await axios.post(apiUrl + "update-lead-install", {
    leadId: installDetails.leadId,
    "workAssign.fiberTeam.fiberTeamAssigned": true // ✅ only one field
  });
}


        else if (taskData.activeTabWorkAssign === "networkTeam") {
          await axios.post(apiUrl + "update-lead-install", {
             leadId: installDetails.leadId,
    "workAssign.networkTeam.networkTeamAssigned": true 
          });
        }
          Swal.fire({
            title: "Task Created Successfully!",
            icon: "success",
          }).then(() => {
            navigate("/task");
          });
        } catch (error) {
          console.log("Error submitting data:", error.response?.data || error.message);
          Swal.fire({
            icon: "error",
            title: "Oops...",
            text: error.response?.data?.message || "Something went wrong!",
          });
        }
      }
    });
  };

  useEffect(() => {
    axios.get(apiUrl + "manage-stock/get-material-type", {}).then((res) => {
      const add_installation = res.data || [];
      console.log("Fetched data:", add_installation); // ✅ Check this output

      setRouterMaterial(add_installation);


    });
  }, []);




  


  // const handleSubmitAssignTask = async (e) => {
  //   e.preventDefault();


  //   Swal.fire({
  //     title: "Do you want to save the Task Assign Details?",
  //     showCancelButton: true,
  //     confirmButtonText: "Save",
  //   }).then(async (result) => {
  //     if (result.isConfirmed) {
  //       try {

  //         const associatedIds = {
  //           installationId: installDetails?._id
  //         }

  //         const datas = { ...taskData, assignedTo: selectedNames, associatedIds }

  //         const response = await axios.post(
  //           `${apiUrl}add-assign-task?page=${page}&tab=verification`,

  //           datas,
  //           { headers: { "Content-Type": "application/json" } }
  //         );

  //         Swal.fire({
  //           title: "Customer Details Added Successfully!",
  //           icon: "success",
  //         }).then(() => {
  //           navigate("/enquiry");
  //         });
  //       } catch (error) {
  //         console.log("Error submitting data:", error.response?.data || error.message);
  //         Swal.fire({
  //           icon: "error",
  //           title: "Oops...",
  //           text: error.response?.data?.message || "Something went wrong!",
  //         });
  //       }
  //     }
  //   });
  // };
useEffect(() => {
    const now = new Date();
    const year = now.getFullYear();
    const month = String(now.getMonth() + 1).padStart(2, "0");
    const day = String(now.getDate()).padStart(2, "0");
    const hours = String(now.getHours()).padStart(2, "0");
    const minutes = String(now.getMinutes()).padStart(2, "0");

    const formattedDate = `${year}-${month}-${day}T${hours}:${minutes}`;

    setTaskData(prev => ({
      ...prev,
      assignDateTime: formattedDate,
    }));
  }, []);


  useEffect(() => {
    if (taskData.assignDateTime) {
      const assignDate = new Date(taskData.assignDateTime);
      const deadlineDate = new Date(assignDate.getTime() + 4 * 60 * 60 * 1000); // +4 hours
      const formattedDeadline = formatDateTimeLocal(deadlineDate);
  
      setTaskData(prev => ({
        ...prev,
        deadline: formattedDeadline
      }));
    }
  }, [taskData.assignDateTime]);



  useEffect(() => {
    setTaskData((prevData) => ({
      ...prevData,
      activeTab: activeTab,
    }));
  }, [activeTab]);


  console.log(pageRefId)


  useEffect(() => {
    axios
      .post(apiUrl + "getdata-install", {
        leadId: locate.state?.leadId,
      })
      .then((res) => {
        const data = res.data.message;

                console.log(data,"data ")


        // Format location string if latitude and longitude exist
        const locationString =
          data.location?.latitude && data.location?.longitude
            ? `${data.location.latitude}, ${data.location.longitude}`
            : "";

        // Set formatted location into installDetails.installlocation

        const updatedDetails = {
          ...data,
          installlocation: locationString, // Add this line
        };

console.log(updatedDetails,"upddated Details")

        setinstallDetails(updatedDetails);

        console.log(installDetails,"setinstall")
        setOriginalData(updatedDetails);
        setpageRefId(data._id);
        setEnquiryId(data._id)
      });
  }, [locate.state?.leadId]);



  const isCurrentTabCompleted = () => {
    if (!installDetails) return false;

    switch (activeTab) {
      case "verification":
        return installDetails.verification?.isCompleted === true;

      case "workAssign":
        const fiberCompleted = installDetails.workAssign?.fiberTeam?.approvedStatus==="Approved";
        const networkCompleted = installDetails.workAssign?.networkTeam?.approvedStatus==="Approved";
        return fiberCompleted === true && networkCompleted === true;
      //  return installDetails.workAssign?.isCompleted === true;


      case "feedback":
        return installDetails.feedback?.isCompleted === true;

      case "payment":
        return installDetails.payment?.isCompleted === true;

      default:
        return false;
    }
  };



  useEffect(() => {
    // Reset edit mode when leaving orderDetails tab
    if (activeTab !== 'orderDetails') {
      setIsEditMode(false);
      setIsEditable(false);
    }
  }, [activeTab]);

  const getFutureDateTime = () => {
    const now = new Date();
    now.setMinutes(now.getMinutes() + 1); // add 1 minute to current time
    return now.toISOString().slice(0, 16); // returns 'YYYY-MM-DDTHH:MM'
  };


  useEffect(() => {
    const fetchMessages = async () => {
      try {


        // fetch enquiry messages
        console.log(installDetails.fromEnquiry.status, "-----------------------------------------------------")
        if (installDetails.fromEnquiry.status == true) {
          const enquPageRefID = installDetails.fromEnquiry.enquiryId

          const response = await axios.get(`${apiUrl}messages/${enquPageRefID}`);

          if (response.status === 200 && Array.isArray(response.data.data)) {

            const enquiryMessages = response.data.data || []

            setMessageData((prev) => [...prev, ...enquiryMessages])

            setEnquiryMessageData(response.data.data); // ✅ Only the array!
          }
        }

        // fetch installation
        const response = await axios.get(`${apiUrl}messages/${pageRefId}`);
        if (response.status === 200 && Array.isArray(response.data.data)) {
          setMessageData((prev) => [...response.data.data, ...prev]); // ✅ Only the array!
        }

      } catch (error) {
        console.error("Error fetching messages:", error);
        // setMessageData([]); // fallback to empty array
      }
    };

    fetchMessages();
  }, [apiUrl, pageRefId]);



  console.log("activeTab:", activeTab);
  console.log("isEditMode:", isEditMode);
  console.log("isEditable:", isEditable);
  console.log("isOpenAssign:", isOpenAssign);

  return (
    <div>

      <Topbar />
      <Container fluid>
        <form onSubmit={handleSubmit}>
          <Row className='mt-4'>
            <Col className='text-start'>
              <h3>Installation</h3>
            </Col>


            <Col>


              {/* <button
  className="blue-btn me-3"
  type="button"
  onClick={() => {
    setTaskData({
      ...taskData,
      name: installDetails.enquirycustomerName || '',
      leadId: installDetails.leadId || '',
    });
    setIsOpenAssign(true);
    console.log("Assign button clicked", isOpenAssign); // Check this log
  }}
>
  <FaUserEdit size={18} /> Assign
</button> */}




              {isOpenAssign && (
                <div className="overlay3">
                  <div className="modal3">
                    <Container>
                      <div className=" text-end mx-2">
                        <button
                          type="button"
                          className="black-btn mx-3"
                          onClick={() => setIsOpenAssign(false)}
                        >
                          Cancel
                        </button>
                        <button
                          type="button"
                          className=" blue-btn mx-3"
                          onClick={handleSubmitAssignTask}
                        >
                          Submit
                        </button>
                      </div>

                      <Row className="mt-4">
                        <Col xs={12} md={6}>
                          <Row>
                            <Col xs={12} md={6} className="text-start">
                              <lable>Task Name</lable>
                              <br />
                              <input
                                type="text"
                                className="form-input"
                                readOnly
                                value={taskData.taskName}
                              />
                            </Col>
                            <Col xs={12} md={6} className="text-start">
                              <lable>Assign Date/Time</lable>
                              <br />
                              <input
                                type="datetime-local"
                                value={taskData.assignDateTime}
                                required
                                  min={getFutureDateTime()} // optional: restrict past values

                                className="form-input"
                                onChange={(e) => handleInputChange('assignDateTime', e.target.value)}
                              />
                            </Col>
                          </Row>
                        </Col>
                        <Col>
                          <Row>

                            {/* <Col xs={12} md={6} className="text-start">
                                  <lable>Task Type</lable>

                                  <br />
                                  <select
                                    onChange={(e) =>
                                      handleInputChange(
                                        "taskType",
                                        e.target.value
                                      )
                                    }
                                    class="dropbtn form-input-select overlay2"
                                  >
                                    <option value="Once">Once</option>
                                    <option value="Daily">Daily</option>
                                    <option value="weekly">Weekly</option>
                                    <option value="Monthy">Monthly</option>
                                    <option value="Custom">Custom</option>
                                  </select>
                                </Col> */}

                            <Col xs={12} md={6} className="text-start">
                              <lable>Task Priority </lable>
                              <br />
                              <select
                                onChange={(e) =>
                                  handleInputChange(
                                    "taskPriority",
                                    e.target.value
                                  )
                                }
                                class="dropbtn form-input-select overlay2"
                              >
                                <option value="Low">Low</option>
                                <option value="High">High</option>
                                <option value="Immediate">Immediate</option>
                              </select>
                            </Col>

                            <Col xs={12} md={6} className="text-start">
                              <lable>Deadline Date/time</lable>
                              <br />
                                                        <input
  type="datetime-local"
  value={taskData.deadline || ""}
  min={getFutureDateTime()} // optional: restrict past values
  onChange={(e) =>
    handleInputChange("deadline", e.target.value)
  }
  className="form-input overlay2"
/>
                            </Col>


                          </Row>
                        </Col>
                      </Row>

                      <Row>
                        <Col xs={12} md={6}>
                          <Row>
                            <Col xs={12} md={6} className="text-start">
                              <lable>Lead ID</lable>
                              <br />
                              <input
                                type="text"
                                value={taskData.leadId}
                                className="form-input overlay2"
                                readOnly
                              />
                            </Col>

                            <Col xs={12} md={6} className="text-start">
                              <lable>Name </lable>
                              <br />
                              <input
                                type="text"
                                onChange={(e) =>
                                  handleInputChange("name", e.target.value)
                                }
                                style={{ textTransform: "capitalize" }}
                                className="form-input "
                                placeholder="Enter Notes "
                                readOnly
                                value={taskData.name}
                              />
                            </Col>
                            {/* <Col xs={12} md={6} className="text-start">
                              <lable>Deadline Time</lable>
                              <br />
                              <input
                                type="time"
                                onChange={(e) =>
                                  handleInputChange("time", e.target.value)
                                }
                                className="form-input overlay2"
                                placeholder=""
                              />
                            </Col> */}
                          </Row>
                        </Col>
                        <Col>
                          <Row>
                            <Col xs={12} md={6} className="text-start">
                              <lable>Task Asign To</lable>
                              <br />
                              <div ref={dropdownRef} style={{ position: 'relative', width: '85%' }}>
                                <div
                                  onClick={toggleDropdown}
                                  style={{
                                    padding: '10px',
                                    border: '2px solid #a7a7a7',
                                    borderRadius: '4px',
                                    cursor: 'pointer',
                                    backgroundColor: '#fff',
                                    display: 'flex',
                                    justifyContent: 'space-between',
                                    alignItems: 'center',
                                    marginTop: "10px"
                                  }}
                                >
                                  <span style={{
                                    overflow: 'hidden',
                                    textOverflow: 'ellipsis',
                                    whiteSpace: 'nowrap'
                                  }}>
                                    {displayText}
                                  </span>
                                  <span>{isOpen ? '▲' : '▼'}</span>
                                </div>

                                {isOpen && (
                                  <div style={{
                                    position: 'absolute',
                                    top: '100%',
                                    left: 0,
                                    right: 0,
                                    marginTop: '5px',
                                    border: '1px solid #ccc',
                                    borderRadius: '4px',
                                    backgroundColor: '#fff',
                                    boxShadow: '0 2px 5px rgba(0,0,0,0.2)',
                                    zIndex: 1000,
                                    maxHeight: '250px',
                                    overflowY: 'auto'
                                  }}>

                                    {/* 🔍 Search Input */}
                                    <input
                                      type="text"
                                      placeholder="Search staff..."
                                      value={searchText}
                                      onChange={(e) => setSearchText(e.target.value)}
                                      style={{
                                        width: '95%',
                                        margin: '10px auto',
                                        display: 'block',
                                        padding: '8px',
                                        borderRadius: '4px',
                                        border: '1px solid #ccc'
                                      }}
                                    />

                                    {/* Filtered Staff List */}
                                    {names.filter(staff =>
                                      staff.staffName.toLowerCase().includes(searchText.toLowerCase())
                                    ).length === 0 ? (
                                      <div style={{ padding: '10px', color: '#888', textAlign: 'center' }}>
                                        No Staffs found
                                      </div>
                                    ) : (
                                      names.filter(staff =>
                                        staff.staffName.toLowerCase().includes(searchText.toLowerCase())
                                      ).map((staff) => (
                                        <label
                                          key={staff._id}
                                          style={{
                                            display: 'flex',
                                            alignItems: 'center',
                                            padding: '10px',
                                            cursor: 'pointer',
                                            borderBottom: '1px solid #eee',
                                          }}
                                        >
                                          <input
                                            type="checkbox"
                                            checked={selectedNames.some(item => item._id === staff._id)}
                                            onChange={() => handleCheckboxChange(staff)}
                                            style={{ marginRight: '10px' }}
                                            required
                                          />
                                          {staff.staffName}
                                        </label>
                                      ))
                                    )}
                                  </div>
                                )}
                              </div>
                            </Col>

                            <Col xs={12} md={6} className="text-start">
                              <lable>Approve Person </lable>
                              <br />
                              <div ref={approveDropdownRef} style={{ position: 'relative', width: '85%', marginTop: '15px' }}>
                                <div
                                  onClick={toggleApproveDropdown}
                                  style={{
                                    padding: '10px',
                                    border: '2px solid #a7a7a7',
                                    borderRadius: '4px',
                                    cursor: 'pointer',
                                    backgroundColor: '#fff',
                                    display: 'flex',
                                    justifyContent: 'space-between',
                                    alignItems: 'center',
                                    marginTop: '-5px'

                                  }}
                                >
                                  <span style={{
                                    overflow: 'hidden',
                                    textOverflow: 'ellipsis',
                                    whiteSpace: 'nowrap'
                                  }}>
                                    {approvePersonText}
                                  </span>
                                  <span>{isApproveOpen ? '▲' : '▼'}</span>
                                </div>

                                {isApproveOpen && (
                                  <div style={{
                                    position: 'absolute',
                                    top: '100%',
                                    left: 0,
                                    right: 0,
                                    marginTop: '5px',
                                    border: '1px solid #ccc',
                                    borderRadius: '4px',
                                    backgroundColor: '#fff',
                                    boxShadow: '0 2px 5px rgba(0,0,0,0.2)',
                                    zIndex: 1000,
                                    maxHeight: '250px',
                                    overflowY: 'auto'
                                  }}>
                                    {/* 🔍 Search Input */}
                                    <input
                                      type="text"
                                      placeholder="Search staff..."
                                      value={searchTerm}
                                      onChange={(e) => setSearchTerm(e.target.value)}
                                      style={{
                                        width: '100%',
                                        padding: '8px 10px',
                                        borderBottom: '1px solid #ccc',
                                        boxSizing: 'border-box',
                                        outline: 'none',
                                        border: 'none'
                                      }}
                                    />

                                    {/* 🧑‍💼 Filtered Staff List */}
                                    {filteredNames.length === 0 ? (
                                      <div style={{ padding: '10px', color: '#888', textAlign: 'center' }}>
                                        No staff found
                                      </div>
                                    ) : (
                                      filteredNames.map((staff) => (
                                        <label
                                          key={staff._id}
                                          style={{
                                            display: 'flex',
                                            alignItems: 'center',
                                            padding: '10px',
                                            cursor: 'pointer',
                                            borderBottom: '1px solid #eee',
                                          }}
                                        >
                                          <input
                                            type="checkbox"
                                            required
                                            checked={approvePersons.some((item) => item._id === staff._id)}
                                            onChange={() => handleApproveCheckboxChange(staff)}
                                            style={{ marginRight: '10px' }}
                                          />
                                          {staff.staffName}
                                        </label>
                                      ))
                                    )}
                                  </div>
                                )}

                              </div>

                            </Col>
                          </Row>
                        </Col>
                      </Row>

                      <Row>
                        <Col xs={12} md={6} className="text-start">
                          <lable>Description</lable>
                          <br />
                          <textarea
                            type="text"
                            onChange={(e) =>
                              handleInputChange(
                                "description",
                                e.target.value
                              )
                            }
                            style={{
                              textTransform: "capitalize",
                              resize: "none",
                            }}
                            className="form-input inputfield-assign "
                            placeholder="Enter Notes "
                          />
                        </Col>
                        <Col>
                          <Row>



                            <Col xs={12} md={6} className="text-start">
                              <lable>Task Status </lable>
                              <br />
                              <input
                                type="text"
                                onChange={(e) =>
                                  handleInputChange(
                                    "taskStatus",
                                    e.target.value
                                  )
                                }
                                // style={{ textTransform: "capitalize" }}
                                style={{
                                  backgroundColor: "#fbdc6e",
                                  color: "rgb(94, 94, 14)",
                                  textTransform: "capitalize",
                                }}
                                className="form-input "
                                readonly
                                value={taskData.taskStatus}
                              />
                            </Col>
                          </Row>
                          <Row>

                          </Row>
                        </Col>
                      </Row>
                    </Container>
                  </div>
                </div>
              )}


            </Col>

            {!isEditable && activeTab === "orderDetails" && (
              <button
                className="black-btn me-2"
                type="button"
                onClick={() => {
                  // Store a deep copy of current form data before editing
                  setOriginalComplaint(JSON.parse(JSON.stringify(installDetails)));
                  setIsEditable(true);
                  setIsEditMode(true);
                }}
              >
                <MdEdit size={18} /> Edit
              </button>
            )}



            {isEditMode && isEditable && (
              <>
                {/* Submit Button */}
                <button className="blue-btn ms-2 me-3 a" type="submit">
                  Submit
                </button>

                {/* Cancel Button */}
                <button
                  className="black-btn ms-2 me-3"
                  type="button"
                  onClick={() => {
                    setinstallDetails(JSON.parse(JSON.stringify(originalComplaint)));
                    setIsEditable(false);
                    setIsEditMode(false);
                  }}
                >
                  Cancel
                </button>
              </>
            )}



            {(
              (activeTab === 'orderDetails') ||
              ['verification', 'payment', 'workAssign', 'workDetails', 'feedback',].includes(activeTab)
            ) && (
                <>




                  {
                  
                  (!isCurrentTabCompleted() && installDetails.leadStatus!=="Cancelled" &&
                    (
                      hideAssignButton ||
                      activeTab === "verification" ||
                      activeTab === "feedback" ||
                      activeTab === "payment"
                    ) ||
                    (
                      hideAssignButton && activeTab === "workAssign" && activeTabWorkAssign === "fiberTeam" &&
                      installDetails?.workAssign?.fiberTeam?.isCompleted !== true

                    ) ||

                    (
                      (
                        hideAssignButton && activeTab === "workAssign" &&
                        installDetails?.workAssign?.networkTeam?.isCompleted !== true

                      )
                    )
                  )  && (
                      <>
                        {
                          (
                            installDetails?.workAssign?.fiberTeam?.isCompleted !== true && activeTabWorkAssign === "fiberTeam" &&installDetails.leadStatus!=="Cancelled" ) && (
                            <button className="blue-btn ms-2 me-3 b" type="submit">Submit</button>
                          )
                        }
                        {
                          (
                            installDetails?.workAssign?.networkTeam?.isCompleted !== true && activeTabWorkAssign === "networkTeam" &&installDetails.leadStatus!=="Cancelled" ) && (
                            <button className="blue-btn ms-2 me-3 c " type="submit">Submit</button>
                          )
                        }


                        
                      </>
                    )}

 


                {(tabInfo?.activeTabWorkAssign === "fiberTeam" && tabInfo?.resubmittedData === true && tabInfo?.activeTabWorkAssign === "networkTeam" &&installDetails.leadStatus!=="Cancelled" ) && (
  <>
 <button className="blue-btn ms-2 me-3 d" type="submit">Submit</button>  </>
)}

{console.log(tabInfo?.resubmittedData === true,(activeTabWorkAssign === "fiberTeam" &&
    installDetails?.workAssign?.fiberTeam?.approvedStatus === "Resubmit"),activeTabWorkAssign === "fiberTeam",installDetails?.workAssign?.fiberTeam?.approvedStatus === "Resubmit")}


{console.log(activeTabWorkAssign==="fiberTeam")}
{/* {tabInfo?.resubmittedData === true &&
 activeTabWorkAssign === "fiberTeam" &&
 installDetails?.workAssign?.fiberTeam?.approvedStatus === "Resubmit" &&
 activeTab === "workAssign" && (
  <button className="blue-btn ms-2 me-3 e" type="submit">
    Submit
  </button>
)} */}





{tabInfo?.resubmittedData === true &&
  activeTabWorkAssign === "networkTeam" &&
  (tabInfo?.reComplete || installDetails?.workAssign?.networkTeam?.approvedStatus === "Resubmit") &&
  installDetails?.leadStatus1 === "Cancelled" &&
  activeTab === "workAssign" && (
    <button className="blue-btn ms-2 me-3 e" type="submit">
      Submit
    </button>
  )}



{activeTab=="feedback" && installDetails.feedback.isCompleted !==true && installDetails.workAssign.isCompleted &&installDetails.leadStatus!=="Cancelled" &&
  (
    
  <button className="blue-btn ms-2 me-3 e" type="submit">
    Submit
  </button>
)}


{installDetails.leadStatus!=="Cancelled" && (
<button style={{width:"100px",heght:"35px",borderRadius:"5px",backgroundColor:"#e92121ff", marginRight:"20px",border:"none",color:"white"}} onClick={(e)=>handleCancel(e)} > Cancel</button>
)}

{installDetails.leadStatus==="Cancelled" &&(
  <div className='cancelled-status-installation'><h6 className='text-white'>Installation Cancelled</h6></div>
)

}
                  {/* <button
                    className="black-btn ms-2 me-3"
                    type="button"
                    onClick={() => {
                      setinstallDetails(JSON.parse(JSON.stringify(originalComplaint)));
                      setIsEditable(false);
                      setIsEditMode(false);
                    }}
                  >
                    Cancel
                  </button> */}

                  {/* {!['Not Feasible', 'Cancelled', 'Converted'].includes(installDetails.leadStatus) && (
                    <button
                      className="blue-btn me-5"
                      type="button"
                      onClick={() => {
                        setTaskData({
                          ...taskData,
                          name: installDetails.enquirycustomerName || '',
                          leadId: installDetails.leadId || '',
                        });
                        setIsOpenAssign(true);
                      }}
                    >
                      <FaUserEdit size={18} /> Assign
                    </button>
                  )} */}
                  {permissions?.Installation?.["Installation Task Assign"]?.Read &&
                    !hideAssignButton &&  installDetails.leadStatus !=="Cancelled" &&
                    activeTab === "workAssign" &&
                    (
                      (activeTabWorkAssign === "fiberTeam" &&
                        installDetails.workAssign?.fiberTeam?.isCompleted === false) ||
                      (activeTabWorkAssign === "networkTeam" &&
                        installDetails.workAssign?.networkTeam?.isCompleted === false)
                    ) &&
                    !(isEditMode && isEditable) && (
                      <button
                        className="blue-btn me-5"
                        type="button"
                        onClick={() => setIsOpenAssign(true)}
                      >
                        <FaUserEdit size={18} /> Assign
                      </button>
                    )}





                </>
              )}
          </Row>



          <div className="tabs-container mt-5 mb-5">
            {/* Tabs */}
            {/* <div className="tabs">
                        <Row>
                            <Col>
                                <button type="button" className='order-details-btn' onClick={() => setActiveTab("orderDetails")}>Order Details</button>

                            </Col>
                            <Col>
                                <button type="button" onClick={() => setActiveTab("verification")}>Verification</button>

                            </Col>
                            <Col>
                                <button type="button" onClick={() => setActiveTab("workAssign")}>Work Assign</button>

                            </Col>
                            <Col>
                                <button type="button" onClick={() => setActiveTab("workDetails")}>Work Details</button>

                            </Col>
                            <Col>
                                <button type="button" onClick={() => setActiveTab("feedback")}>Feedback</button>

                            </Col>
                            <Col>
                                <button type="button" onClick={() => setActiveTab("payment")}>Payments</button>

                            </Col>


                        </Row>
                    </div> */}

            <div className="tabs">
  <Row className="mb-3">
    {/* Order Details */}
    <Col>
      <button
        type="button"
        className={`order-details-btn ${activeTab === "orderDetails" ? "active" : "inactive"}`}
        onClick={() => setActiveTab("orderDetails")}
      >
        Order Details
      </button>
    </Col>

    {/* Verification */}
    <Col>
      <button
        type="button"
        className={`order-details-btn ${activeTab === "verification" ? "active" : "inactive"}`}
        onClick={() => setActiveTab("verification")}
      >
        Verification
      </button>
    </Col>

    {/* Work Assign */}
    {installDetails?.verification?.isCompleted && (
      <Col>
        <button
          type="button"
          className={`order-details-btn ${activeTab === "workAssign" ? "active" : "inactive"}`}
          onClick={() => setActiveTab("workAssign")}
        >
          Work Assign
        </button>
      </Col>
    )}

    {/* Work Details */}
    {installDetails?.workAssign?.isCompleted && (
      <Col>
        <button
          type="button"
          className={`order-details-btn ${activeTab === "workDetails" ? "active" : "inactive"}`}
          onClick={() => setActiveTab("workDetails")}
        >
          Work Details
        </button>
      </Col>
    )}

    {/* Feedback */}
    {installDetails?.workAssign?.isCompleted && (
      <Col>
        <button
          type="button"
          className={`order-details-btn ${activeTab === "feedback" ? "active" : "inactive"}`}
          onClick={() => setActiveTab("feedback")}
        >
          Feedback
        </button>
      </Col>
    )}

    {/* Payment */}
    {installDetails?.leadStatus !== "Cancelled" && (
      <Col>
        <button
          type="button"
          className={`order-details-btn ${activeTab === "payment" ? "active" : "inactive"}`}
          onClick={() => setActiveTab("payment")}
        >
          Payment
        </button>
      </Col>
    )}
  </Row>
</div>



            {/* Dynamic Content */}
            <div className="tab-content">

              {renderContent()}






            </div>



          </div>
        </form>

      </Container>

      <Row className="container ms-3 me-5">
        <Col md={6} sm={12}>
          <div>
            {Array.isArray(messageData) && messageData.length > 0 ? (
              messageData.map((msg) => (
                <MessageBox key={msg._id} message={msg} />
              ))
            ) : (
              <div className="text-muted">No messages available.</div>
            )}
          </div>
        </Col>

        <Col md={6} sm={12}>
          <div className="compact-updates-history">
            <div className="compact-updates-header">Updates History</div>
            {Array.isArray(messageData) && messageData.length > 0 ? (
              messageData.map((data, index) => (
                <div className="compact-update text-center" key={index}>
                  <div className="compact-update-date text-center">
                    {data.updatesHistory.date ? (
                      new Date(data.updatesHistory.date).toLocaleDateString("en-GB") +
                      " - " +
                      new Date(data.updatesHistory.date)
                        .toLocaleTimeString("en-US", {
                          hour: "2-digit",
                          minute: "2-digit",
                          hour12: true,
                        })
                    ) : (
                      "No date"
                    )}
                  </div>

                  <div className="compact-update-user text-center">
                    {data.updatesHistory?.staff?.name || "Unknown"}
                  </div>

                  <div
                    className="compact-update-status text-center"
                    style={{ color: data.colorCode || "#000000" }}
                  >
                    {data.updatesHistory?.status || "No Status"}
                  </div>
                </div>
              ))
            ) : (
              <div className="text-muted text-center">No update history available.</div>
            )}
          </div>
        </Col>
      </Row>


    </div>
  )
}